"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const app_controller_1 = require("./app.controller");
const app_service_1 = require("./app.service");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_config_1 = require("../../../service-lib/src/lib/database/typeorm.config");
const service_communication_1 = require("../../../service-lib/src/lib/service-communication");
const opportunity_module_1 = require("./opportunity/opportunity.module");
const meeting_module_1 = require("./meeting/meeting.module");
const environment_1 = require("../../../service-lib/src/lib/environment");
const acl_service_1 = require("../../../service-lib/src/lib/acl.service");
const service_lib_module_1 = require("../../../service-lib/src/lib/service-lib.module");
const task_module_1 = require("./task/task.module");
const note_module_1 = require("./note/note.module");
let AppModule = class AppModule {
    constructor(serviceRegistrationService) {
        this.serviceRegistrationService = serviceRegistrationService;
    }
    async onModuleInit() {
        const serviceInfo = {
            name: "opportunity-service",
            url: `${environment_1.ENV.URL_OPPORTUNITY_SERVICE}`,
            port: environment_1.ENV.PORT_OPPORTUNITY_SERVICE,
            healthCheck: "/health",
            status: "active",
        };
        await this.serviceRegistrationService.registerService(serviceInfo);
    }
};
exports.AppModule = AppModule;
exports.AppModule = AppModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forRoot(typeorm_config_1.typeOrmConfig),
            opportunity_module_1.OpportunityModule, service_lib_module_1.InsuranceWellnessHubServiceLibModule,
            meeting_module_1.MeetingModule,
            task_module_1.TaskModule,
            note_module_1.NoteModule,
            service_lib_module_1.InsuranceWellnessHubServiceLibModule,
        ],
        controllers: [app_controller_1.AppController],
        providers: [app_service_1.AppService, service_communication_1.ServiceRegistrationService, acl_service_1.AclService],
    }),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof service_communication_1.ServiceRegistrationService !== "undefined" && service_communication_1.ServiceRegistrationService) === "function" ? _a : Object])
], AppModule);
